// extracted by mini-css-extract-plugin
export var outerContainer = "pJuzI";
export var swipeableContentContainer = "t28Ow";